import { AnswerCommand } from 'core/commands/elements/answers/answer.abstract.command';
import { tactileoAnswersDTOTypes } from 'utils/activityItem.util';

export class SortingQuestionAnswerCommand extends AnswerCommand {
  constructor(sortingQuestion) {
    super(tactileoAnswersDTOTypes.SORTING_QUESTION, sortingQuestion);
    this.values = sortingQuestion.values.map(({ id }) => id);
  }
}
